export default "__VITE_PUBLIC_ASSET__d9eb371a__"